import { render, staticRenderFns } from "./stokDetay.vue?vue&type=template&id=37bf19fc&scoped=true&"
import script from "./stokDetay.vue?vue&type=script&lang=js&"
export * from "./stokDetay.vue?vue&type=script&lang=js&"
import style0 from "./stokDetay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./stokDetay.vue?vue&type=style&index=1&id=37bf19fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf19fc",
  null
  
)

export default component.exports